import {
  SET_IS_CONFIRM_ERROR,
  SET_IS_EMAIL_CONFIRMED,
  SET_IS_LOGIN_ERROR,
  SET_RECOVERY_TOKEN,
  SET_TOKEN
} from "./auth-types";

const initialState = {
  token: '',
  isEmailConfirmed: false,
  isLoginError: false,
  recoveryToken: null,
  isConfirmError: false
}

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN: return {...state, token: action.token}
    case SET_IS_EMAIL_CONFIRMED: return {...state, isEmailConfirmed: action.isEmailConfirmed}
    case SET_IS_LOGIN_ERROR: return {...state, isLoginError: action.isLoginError}
    case SET_RECOVERY_TOKEN: return {...state, recoveryToken: action.recoveryToken}
    case SET_IS_CONFIRM_ERROR: return {...state, isConfirmError: action.isConfirmError}
    default: return state
  }
}
